import { FileRejection } from 'react-dropzone';
import { v4 as uuidV4 } from 'uuid';

import { AttachmentDraft } from '../types';

const createRejectedDraft = ({
  file,
  error,
}: {
  file: FileRejection;
  error?: AttachmentDraft['error'];
}): AttachmentDraft => ({
  attachmentId: uuidV4(),
  file: file.file,
  uploaded: false,
  rejected: true,
  error,
});

export default createRejectedDraft;
